<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	import { localReq, postReq } from '../../../services/http';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Helpers
	import { get_local_ip, real_id } from '../../../helpers/interface_helpers';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Design system components
	import { Alert, Toggle } from '@Shelly/shelly-design-system';
	//Components
	import NetworkModal from '../NetworkComponents/NetworkModal.svelte';
	import NetworkConnectedStatus from '../NetworkComponents/NetworkConnectedStatus.svelte';
	//Types
	import type { SettingRequest } from '../../../types/requests/settings/setting';
	import type { Device } from '../../../types/Device';
	import { capFirstChar } from '../../../helpers/utilities';
	import { requestEditDevice } from 'src/components/Lists/list-helpers';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device;
	export let isOffline;

	const id = real_id(device.id);

	let settings = $settingsStore;
	$: statusStore = getDeviceStatus(id);
	$: status = $statusStore;

	let enabled = settings?.cloud.enabled;
	$: connected = status?.cloud.connected;
	let showModal = false;

	const local_ip = get_local_ip(id);

	const saveSetting = async () => {
		let newEnabledValue = enabled;

		const res: SettingRequest = local_ip
			? await localReq(
					device,
					`${local_ip}/settings/cloud/?enabled=${Number(newEnabledValue)}`,
					'get',
					{},
					20000,
					true,
				)
			: await postReq('/device/settings/cloud_disable', { id }, 20000);

		if (res.isok) {
			enabled = newEnabledValue;
			settings.cloud.enabled = enabled;
			devices_settings.update_devices_settings(id, settings);
			if (!enabled) {
				requestEditDevice({ ...device, cloud_online: false });
			}
		} else {
			toggleEnabled();
		}

		onSettingsResponse(res, device);
		close();
	};

	const toggleEnabled = () => {
		enabled = !enabled;
	};

	const handleToggleClick = (e) => {
		enabled = e.target.checked;
		showModal = true;
	};
</script>

<Toggle
	size="m"
	class="mb-s"
	checked={enabled}
	on:click={handleToggleClick}
	disabled={isOffline}
	info={$showNewLayout
		? $format('cloud_description', {
				default:
					'Connecting your Shelly to the cloud allows you to control it remotely, receive notifications and updates about your devices.',
			})
		: undefined}
	id="toggle-ngv6pcd"
>
	{capFirstChar(
		$showNewLayout
			? $format('sub_settings_title_cloud', { default: 'cloud' })
			: $format('option_enable', { default: 'enable' }),
	)}
</Toggle>

<NetworkConnectedStatus connected={enabled && connected} />

{#if !$showNewLayout}
	<Alert
		heading={$format('cloud_description', {
			default:
				'Connecting your Shelly to the cloud allows you to control it remotely, receive notifications and updates about your devices.',
		})}
	/>
{/if}

<NetworkModal
	bind:showModal
	on:confirm={saveSetting}
	on:close={toggleEnabled}
	{isOffline}
	title={enabled
		? $format('enable_cloud_connection_title', {
				default: 'Enable Cloud Connection?',
			})
		: $format('disable_cloud_connection_title', {
				default: 'Disable Cloud Connection?',
			})}
	btnTexts={{
		cancelText: '',
		saveText: enabled ? $format('button_enable') : $format('disable'),
	}}
>
	{#if enabled}
		<!-- TODO: What should the text be when enable -->
		{$format('enable_disable_cloud_msg', {
			values: {
				enable_disable: enabled ? $format('option_enable') : $format('option_disable'),
				default: `Are you sure you want to {enable_disable} cloud for this device?`,
			},
		})}
	{:else}
		{$format('disable_cloud_warning_modal', {
			default:
				'If you disable the device cloud support, you will lose connection to your device from outside its local network.',
		})}
	{/if}
</NetworkModal>
